import { render, staticRenderFns } from "./InputSuggestion.vue?vue&type=template&id=c0c5da58&"
import script from "./InputSuggestion.vue?vue&type=script&lang=js&"
export * from "./InputSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./InputSuggestion.vue?vue&type=style&index=0&id=c0c5da58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports